/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRunClubEventDto } from '../model';
// @ts-ignore
import type { PaginatedRunClubEventsResponseDto } from '../model';
// @ts-ignore
import type { UpdateRunClubEventDto } from '../model';
/**
 * RunClubEventsApi - axios parameter creator
 * @export
 */
export const RunClubEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a run club event with distances and pace groups
         * @param {CreateRunClubEventDto} createRunClubEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerCreate: async (createRunClubEventDto: CreateRunClubEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRunClubEventDto' is not null or undefined
            assertParamExists('runClubEventsControllerCreate', 'createRunClubEventDto', createRunClubEventDto)
            const localVarPath = `/api/run-club-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRunClubEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all run club events with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 10, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerFindAllPaginated: async (page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/run-club-events/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get run club event by ID
         * @param {string} id Run club event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerFindById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runClubEventsControllerFindById', 'id', id)
            const localVarPath = `/api/run-club-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update run club event and its children
         * @param {string} id Run club event ID
         * @param {UpdateRunClubEventDto} updateRunClubEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerUpdate: async (id: string, updateRunClubEventDto: UpdateRunClubEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runClubEventsControllerUpdate', 'id', id)
            // verify required parameter 'updateRunClubEventDto' is not null or undefined
            assertParamExists('runClubEventsControllerUpdate', 'updateRunClubEventDto', updateRunClubEventDto)
            const localVarPath = `/api/run-club-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRunClubEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RunClubEventsApi - functional programming interface
 * @export
 */
export const RunClubEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RunClubEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a run club event with distances and pace groups
         * @param {CreateRunClubEventDto} createRunClubEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runClubEventsControllerCreate(createRunClubEventDto: CreateRunClubEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runClubEventsControllerCreate(createRunClubEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunClubEventsApi.runClubEventsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all run club events with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 10, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runClubEventsControllerFindAllPaginated(page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRunClubEventsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runClubEventsControllerFindAllPaginated(page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunClubEventsApi.runClubEventsControllerFindAllPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get run club event by ID
         * @param {string} id Run club event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runClubEventsControllerFindById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runClubEventsControllerFindById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunClubEventsApi.runClubEventsControllerFindById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update run club event and its children
         * @param {string} id Run club event ID
         * @param {UpdateRunClubEventDto} updateRunClubEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runClubEventsControllerUpdate(id: string, updateRunClubEventDto: UpdateRunClubEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runClubEventsControllerUpdate(id, updateRunClubEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunClubEventsApi.runClubEventsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RunClubEventsApi - factory interface
 * @export
 */
export const RunClubEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RunClubEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a run club event with distances and pace groups
         * @param {CreateRunClubEventDto} createRunClubEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerCreate(createRunClubEventDto: CreateRunClubEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.runClubEventsControllerCreate(createRunClubEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all run club events with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 10, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerFindAllPaginated(page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRunClubEventsResponseDto> {
            return localVarFp.runClubEventsControllerFindAllPaginated(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get run club event by ID
         * @param {string} id Run club event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerFindById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.runClubEventsControllerFindById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update run club event and its children
         * @param {string} id Run club event ID
         * @param {UpdateRunClubEventDto} updateRunClubEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runClubEventsControllerUpdate(id: string, updateRunClubEventDto: UpdateRunClubEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.runClubEventsControllerUpdate(id, updateRunClubEventDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RunClubEventsApi - object-oriented interface
 * @export
 * @class RunClubEventsApi
 * @extends {BaseAPI}
 */
export class RunClubEventsApi extends BaseAPI {
    /**
     * 
     * @summary Create a run club event with distances and pace groups
     * @param {CreateRunClubEventDto} createRunClubEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunClubEventsApi
     */
    public runClubEventsControllerCreate(createRunClubEventDto: CreateRunClubEventDto, options?: RawAxiosRequestConfig) {
        return RunClubEventsApiFp(this.configuration).runClubEventsControllerCreate(createRunClubEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all run club events with pagination
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Items per page (default: 10, max: 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunClubEventsApi
     */
    public runClubEventsControllerFindAllPaginated(page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return RunClubEventsApiFp(this.configuration).runClubEventsControllerFindAllPaginated(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get run club event by ID
     * @param {string} id Run club event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunClubEventsApi
     */
    public runClubEventsControllerFindById(id: string, options?: RawAxiosRequestConfig) {
        return RunClubEventsApiFp(this.configuration).runClubEventsControllerFindById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update run club event and its children
     * @param {string} id Run club event ID
     * @param {UpdateRunClubEventDto} updateRunClubEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunClubEventsApi
     */
    public runClubEventsControllerUpdate(id: string, updateRunClubEventDto: UpdateRunClubEventDto, options?: RawAxiosRequestConfig) {
        return RunClubEventsApiFp(this.configuration).runClubEventsControllerUpdate(id, updateRunClubEventDto, options).then((request) => request(this.axios, this.basePath));
    }
}

